import  { componentAttributeTypes, attributeTypes } from "vagaro-website-rendering/src/components/Definitions/AttributeTypes";
import  { getNodeComponentAttributeValue, setNodeComponentAttributeValue } from "vagaro-website-rendering/src/components/Definitions/LayoutNode";
import { WBRenderProps } from "vagaro-website-rendering/src/components/Definitions/WBRenderProps";
import { GetNodeDomAttributes } from "vagaro-website-rendering/src/components/Utilities/GetNodeDomAttributes";
import BusinessPlaceHolder from "./BusinessDataRendering/BusinessPlaceHolder";
import { ResizeableType, WBComponent } from "./WBComponent";
import { GenericBusinessControl } from "vagaro-website-rendering/src/components/Binding/GenericBusinessControl";
import { wBComponentTypeNames } from "vagaro-website-rendering/src/components/Definitions/WBComponentTypeNames";
import { defaultDropList } from "../Data/WBComponentDefaults";
import { Fragment } from "react";
import { AttributeDefinition, AttributeInputType } from "../Data/WBData";
import { NodeCSSClassDefinition } from "./NodeGlobalStyleGenerator";


export default class BusinessLocation extends WBComponent {

    constructor() {
        super();
        this.typename = wBComponentTypeNames.businessLocation;
        this.displayName = "Locations";
        this.description = "This component is will show all the locations selected in your page settings for multi-location.";
        this.dropList = defaultDropList;
        this.primaryEditAttributes = ["mapView", "isShowLogo", "clickpage", "locdisplaytype","showBusinessFirst","panelRadius"]
        this.colorFields = ["panelColor","locText","locText2","locHighlight","locbordercolor",];
        this.editList = [...this.colorFields,...this.primaryEditAttributes,"locbordercolor", attributeTypes.width, attributeTypes.height];
        this.contentEditable = false;

        this.icon = <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M8 0.875C12.1309 0.875 15.5 4.24414 15.5 8.375C15.5 12.5352 12.1309 15.875 8 15.875C3.83984 15.875 0.5 12.5352 0.5 8.375C0.5 4.24414 3.83984 0.875 8 0.875ZM8 14.4688C8.20508 14.4688 8.76172 14.2637 9.37695 13.0625C9.64062 12.5352 9.8457 11.9199 10.0215 11.1875H5.94922C6.125 11.9199 6.33008 12.5352 6.59375 13.0625C7.20898 14.2637 7.76562 14.4688 8 14.4688ZM5.71484 9.78125H10.2559C10.3145 9.3418 10.3438 8.87305 10.3438 8.375C10.3438 7.90625 10.3145 7.4375 10.2559 6.96875H5.71484C5.65625 7.4375 5.65625 7.90625 5.65625 8.375C5.65625 8.87305 5.65625 9.3418 5.71484 9.78125ZM10.0215 5.5625C9.8457 4.85938 9.64062 4.24414 9.37695 3.7168C8.76172 2.51562 8.20508 2.28125 8 2.28125C7.76562 2.28125 7.20898 2.51562 6.59375 3.7168C6.33008 4.24414 6.125 4.85938 5.94922 5.5625H10.0215ZM11.6621 6.96875C11.7207 7.4375 11.75 7.90625 11.75 8.375C11.75 8.87305 11.7207 9.3418 11.6621 9.78125H13.918C14.0352 9.3418 14.0938 8.87305 14.0938 8.375C14.0938 7.90625 14.0352 7.4375 13.918 6.96875H11.6621ZM10.5195 2.83789C10.9297 3.59961 11.252 4.53711 11.457 5.5625H13.3906C12.7754 4.36133 11.75 3.39453 10.5195 2.83789ZM5.45117 2.83789C4.2207 3.39453 3.19531 4.36133 2.58008 5.5625H4.51367C4.71875 4.53711 5.04102 3.59961 5.45117 2.83789ZM1.90625 8.375C1.90625 8.87305 1.93555 9.3418 2.05273 9.78125H4.30859C4.25 9.3418 4.25 8.87305 4.25 8.375C4.25 7.90625 4.25 7.4375 4.30859 6.96875H2.05273C1.93555 7.4375 1.90625 7.90625 1.90625 8.375ZM13.3906 11.1875H11.457C11.252 12.2422 10.9297 13.1797 10.5195 13.9414C11.75 13.3848 12.7754 12.418 13.3906 11.1875ZM4.51367 11.1875H2.58008C3.19531 12.418 4.2207 13.3848 5.45117 13.9414C5.04102 13.1797 4.71875 12.2422 4.51367 11.1875Z" fill="#333333" /></svg>
        this.resizeType = ResizeableType.All;

        this.cssDefinitions = [
            new NodeCSSClassDefinition(".location-box",
                [
                    {key:"locbordercolor",  cssProperty: "border-color",    default: "" },
                    {key:"panelColor",      cssProperty: "background",      default: "" },
                    {key:"panelRadius",     cssProperty: "border-radius",   default: "" },


                ]),
                new NodeCSSClassDefinition(".location-box h3",


                    [
                        {key:"locText",  cssProperty: "color",    default: "" },
                    ]),
                new NodeCSSClassDefinition(".location-box a",


                    [
                        {key:"locText2",  cssProperty: "color",    default: "" },
                    ]),
                new NodeCSSClassDefinition(".location-box:hover",
                [
                    {key:"locHighlight",  cssProperty: "background-color",    default: "" },


                ]),
                new NodeCSSClassDefinition(".location-box..active-cardbox ",
                    [
                        {key:"locHighlight",  cssProperty: "background-color",    default: "" },

                    ]),
        ]
    }



    getComponentSpecificAttributeDefinitions(): AttributeDefinition[] {
        return [
            new AttributeDefinition("mapView", "Default View", "", AttributeInputType.MapButtonField,
                [{ label: "List View", value: "1" }, { label: "Map View", value: "2" }]),

            new AttributeDefinition("isShowLogo", "Logo", "", AttributeInputType.ButtonField,
                [{ label: "Show Logo", value: "true" }, { label: "Hide Logo", value: "false" }]),
            new AttributeDefinition("showBusinessFirst","Search Order","",AttributeInputType.SelectField,
            [{label:"Show Locations First",value:""},{label:"Show Businesses First",value:"reverse"}]),

            new AttributeDefinition("clickpage", "On Click Direct To", "", AttributeInputType.DuplicatedPageSelectField),
            new AttributeDefinition("locdisplaytype", "Display Locations By", "", AttributeInputType.SelectField,
                [
                    { label: "Business Name", value: "1" },
                    { label: "Address", value: "2" },
                ]
            ),
            new AttributeDefinition("locbordercolor", "Border Color", "", AttributeInputType.ColorField),
            new AttributeDefinition("locText", "Title Color", "", AttributeInputType.ColorField),
            new AttributeDefinition("locText2", "Location Color", "", AttributeInputType.ColorField),
            new AttributeDefinition("locHighlight", "Highlight Color", "", AttributeInputType.ColorField),
        ]
    }

    RenderLayout({ component, screenSize, userContext: siteData, isEditor }: WBRenderProps) {
        const bid = getNodeComponentAttributeValue(component, componentAttributeTypes.multiLocation, "");
        const atts = GetNodeDomAttributes("w-full max-100 vb-control multi-business-details-padding resizable-container", component, screenSize, isEditor);

        let url = "";
        let pageId = getNodeComponentAttributeValue(component, "clickpage", "");
        let layout = getNodeComponentAttributeValue(component, "locdisplaytype", "1");
        let layoutID = getNodeComponentAttributeValue(component, "mapView", "1");
        let reverse = getNodeComponentAttributeValue(component, "showBusinessFirst", "");
        let isShowLogo = getNodeComponentAttributeValue(component, "isShowLogo", "true");

        let foundPage = null;
        if (pageId.length > 2) {
            for (let i = 0; i < siteData.pages.length; i++) {

                let page = siteData.pages[i];
                if (page.pageId == pageId) {
                    foundPage = page;
                    url = page.url;

                }

                if (page.children) {
                    for (let ii = 0; ii < page.children.length; ii++) {
                        let child = page.children[ii];
                        if (child.pageId == pageId) {
                            foundPage = child;
                            url = child.url;
                        }
                    }
                }

                if (url.length > 1) {
                    break;
                }
            }
        }

        if (foundPage && !foundPage.isDuplicateAllLocationPage) { //no longer a duplicated page so reset it
            url = "";
            setNodeComponentAttributeValue(component, "clickpage", "");
        }

        if (url.length < 1) {
            url = ".";
        }

        if (isEditor) {
            if (layoutID == "1" && typeof (window as any).GoToTableView != 'undefined' && (window as any).GoToTableView != null) {
                (window as any).GoToTableView();
            }
            else if (layoutID == "2" && typeof (window as any).GoToChartView != 'undefined' && (window as any).GoToChartView != null) {
                (window as any).GoToChartView();
            }
        }

        if (isShowLogo == "true") {
            if (typeof (window as any).IsShowLogo != 'undefined' && (window as any).IsShowLogo != null) {
                (window as any).IsShowLogo("true");
            }
        }
        else {
            if (typeof (window as any).IsShowLogo != 'undefined' && (window as any).IsShowLogo != null) {
                (window as any).IsShowLogo("false");
            }
        }


        if (!isEditor) {
            return <>

                <a style={{ display: "none" }} id='location-page-link' href={url} >.</a>
                <BusinessPlaceHolder node={component} dataKey="location" layout={layout+reverse} classNames={atts.className} /></>
        }
        return (
            <Fragment>
                <style>
                    {super.GetComponentGlobalCSS(component, true)}

                </style>
                <a style={{ display: "none" }} id='location-page-link' href={url} >.</a>
                <div {...atts}>
                    <GenericBusinessControl key={component.id + bid} bLocationId={bid} layout={layout+reverse} dataKey="location" node={component} userContext={siteData} filters={layoutID} isShowLogo={isShowLogo} />
                </div>
            </Fragment>
        )
    }
}
